
import { defineComponent, ref, watch } from 'vue';
import RoleSelect from '@/components/common/RoleSelect.vue';
import ServiceDeskSelect from '@/components/common/ServiceDeskSelect.vue';
import { RuleObject } from 'ant-design-vue/lib/form';
import { verifyEmail, verifyPhone } from '@/utils/verify.util';

const statusList = [
  {
    label: '已停用',
    value: 0
  },
  {
    label: '已启用',
    value: 1
  },
  {
    label: '待激活',
    value: 2
  }
]

export default defineComponent({
  props: {
    serviceDeskId: { // 默认选中的客服组
      type: Number
    }
  },
  components: {
    RoleSelect,
    ServiceDeskSelect
  },
  setup (props, ctx) {
    const formRef = ref()
    const labelCol = ref({
      style: {
        width: '80px'
      }
    })
    const cacheQuery = localStorage.getItem('engineer_senior_search')
    const defaultQuery = JSON.stringify({
      name: '',
      email: '',
      phone: '',
      externalId: '',
      roleId: null,
      defaultServiceDeskId: null,
      serviceDeskId: props.serviceDeskId,
      status: null,
      searchType: 'ADVANCEDQUERY'
    })
    const searchModel = cacheQuery ? ref(JSON.parse(cacheQuery)) : ref(JSON.parse(defaultQuery))
    const checkEmail = async (rule: RuleObject, value: string) => {
      if (value && !verifyEmail(value)) {
        return Promise.reject('请输入正确的邮箱格式')
      }
      return Promise.resolve()
    }
    const checkPhone = async (rule: RuleObject, value: string) => {
      if (value && !verifyPhone(value)) {
        return Promise.reject('请输入正确的手机格式')
      }
      return Promise.resolve()
    }
    const rules = {
      email: [
        { validator: checkEmail, trigger: 'blur' }
      ],
      phone: [
        { validator: checkPhone, trigger: 'blur' }
      ]
    }

    watch(
      () => props.serviceDeskId, 
      (id) => {
        searchModel.value.serviceDeskId = id
      }
    )
 
    function handleSubmit () {
      formRef.value.validate().then(() => {
        ctx.emit('submit', searchModel.value)
      })
    }

    function handleClear () {
      formRef.value.resetFields()
    }

    return {
      statusList,
      formRef,
      labelCol,
      searchModel,
      rules,
      handleSubmit,
      handleClear
    }
  }
})
